import { GET_ZUGAENGE } from '../lib/graphql/queries.ts';
import { useQuery } from '@apollo/client/react';

export function useZugangTitelVergeben(eigeneUid?: string): string[] {
  const { data } = useQuery(GET_ZUGAENGE);

  if (data?.zugaenge.__typename !== 'ZugangQuerySuccess') {
    return [];
  }

  return data.zugaenge.zugaenge
    .filter((zugang) => zugang.uid !== eigeneUid)
    .map((zugang) => normalisiereTitel(zugang.beschreibung));
}

export function normalisiereTitel(titel: string): string {
  return titel.trim().toLowerCase();
}
